import {
  FormValidations,
  SetValidationRuleFunction,
  ValidationActionType,
} from "features/shared/forms/hooks/useForm";
import ValidationRule from "features/validation/rules/ValidationRule";

export const getAddressValidations = (
  objectPrefix: string
): FormValidations => {
  let validations: FormValidations = {};

  validations[`${objectPrefix}.evidenceNumber`] = {
    required: true,
    type: "OnlyRequired",
  };

  validations[`${objectPrefix}.city`] = {
    required: true,
    type: "OnlyRequired",
  };

  validations[`${objectPrefix}.zipCode`] = {
    required: true,
    type: "OnlyRequired",
  };

  return validations;
};

export const setAddressValidations = (
  objectPrefix: string,
  setValidationRule: SetValidationRuleFunction,
  action: ValidationActionType = "add"
) => {
  const validations = getAddressValidations(objectPrefix);

  for (const [key, rule] of Object.entries(validations)) {
    setValidationRule(key, rule, action);
  }
};

export const setCadastralInfoValidations = (
  objectPrefix: string,
  setValidationRule: SetValidationRuleFunction,
  action: ValidationActionType = "add"
) => {
  setValidationRule(
    `${objectPrefix}.cadastralTerritory`,
    getRequiredRule(),
    action
  );
  setValidationRule(
    `${objectPrefix}.parcelNumber`,
    getRequiredRule(),
    action
  );
};

export const setEvidenceNumberValidation = (
  objectPrefix: string,
  setValidationRule: SetValidationRuleFunction,
  action: ValidationActionType = "add"
) => {
  setValidationRule(
    `${objectPrefix}.evidenceNumber`,
    getRequiredRule(),
    action
  );
};

// PRIVATE
const getRequiredRule = (): ValidationRule => {
  return {
    required: true,
    type: "OnlyRequired",
  };
};
